// 复制文本
function copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(
    function () {
      showMessage("success", "Copy success", { showClose: false });
    },
    function (err) {
      showMessage("error", "Copy failed", { showClose: false });
    }
  );
}

// 创建遮罩层
function createOverlay() {
  if (document.querySelector("body>#custom-overlay")) {
    return document.querySelector("body>#custom-overlay");
  }
  const overlay = document.createElement("div");
  overlay.id = "custom-overlay";
  overlay.className = "custom-overlay";
  document.body.appendChild(overlay);
  return overlay;
}

// 创建loading
function createLoading() {
  const overlay = createOverlay();
  if (overlay.querySelector("#custom-loading")) {
    return overlay;
  }
  const loading = document.createElement("div");
  loading.id = "custom-loading";
  loading.className = "custom-loading";
  overlay.appendChild(loading);
  return overlay;
}

// 打开自定义弹窗
function openCustomModal(id) {
  const overlay = createOverlay();
  const modal = document.getElementById(id);
  if (!overlay || !modal) return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
  modal.classList.add("active");
  // 点击遮罩层关闭
  overlay.addEventListener("click", function () {
    modal.classList.remove("active");
    overlay.remove();
  });
}

// 关闭自定义弹窗
function closeCustomModal(id) {
  const overlay = document.querySelector("body>#custom-overlay");
  const modal = document.getElementById(id);
  modal?.classList.remove("active");
  overlay?.remove();
}

// 移动端客服按钮点击弹出框
function showServicePopup() {
  let popupHTML = `
      <div class="customer-service-popconfirm">
      <div class="close-btn">&times;</div>
    <div class="customer-service-popconfirm-title">
      <p class="bold">Need help?</p>
      <p class="subtitle">Mon - Fri from 9AM to 5PM (PST)</p>
    </div>
    <div class="customer-service-popconfirm-content">
      <a class="content-item" href="/pages/helpcenter">
        <svg
          t="1751511263867"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6672"
          width="32"
          height="32"
        >
          <path d="M463.99957 784.352211c0 26.509985 21.490445 48.00043 48.00043 48.00043s48.00043-21.490445 48.00043-48.00043c0-26.509985-21.490445-48.00043-48.00043-48.00043S463.99957 757.842226 463.99957 784.352211z" fill="#707070" p-id="6673"></path><path d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128.287273c-211.584464 0-383.712727 172.128262-383.712727 383.712727 0 211.551781 172.128262 383.712727 383.712727 383.712727 211.551781 0 383.712727-172.159226 383.712727-383.712727C895.712727 300.415536 723.551781 128.287273 512 128.287273z" fill="#707070" p-id="6674"></path><path d="M512 673.695256c-17.664722 0-32.00086-14.336138-32.00086-31.99914l0-54.112297c0-52.352533 39.999785-92.352318 75.32751-127.647359 25.887273-25.919957 52.67249-52.67249 52.67249-74.016718 0-53.343368-43.07206-96.735385-95.99914-96.735385-53.823303 0-95.99914 41.535923-95.99914 94.559333 0 17.664722-14.336138 31.99914-32.00086 31.99914s-32.00086-14.336138-32.00086-31.99914c0-87.423948 71.775299-158.559333 160.00086-158.559333s160.00086 72.095256 160.00086 160.735385c0 47.904099-36.32028 84.191695-71.424378 119.295794-27.839699 27.776052-56.575622 56.511974-56.575622 82.3356l0 54.112297C544.00086 659.328155 529.664722 673.695256 512 673.695256z" fill="#707070" p-id="6675"></path>
        </svg>
        <p>FAQS</p>
      </a>
      <a class="content-item" onclick="copyToClipboard('18888912855')">
        <svg
          t="1751511309088"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="7859"
          width="32"
          height="32"
        >
          <path d="M737.17551 923.167347c-40.228571 0-86.204082-7.314286-134.269388-22.465306-114.938776-36.04898-228.310204-110.759184-318.693877-210.546939-135.836735-149.942857-201.142857-299.363265-188.081633-432.587755 3.657143-32.914286 14.628571-74.710204 64.261225-108.669388 38.138776-30.302041 81.502041-48.587755 115.461224-47.542857 35.526531 0.522449 48.065306 13.061224 84.636735 66.873469C416.391837 245.55102 420.571429 284.212245 418.481633 306.155102c-3.657143 36.571429-24.032653 52.244898-41.795919 66.35102-4.702041 3.657143-8.881633 6.791837-12.538775 10.44898-21.942857 28.212245-49.110204 66.873469 66.35102 185.991837 98.742857 94.563265 151.510204 106.057143 173.97551 104.489796 17.240816-1.044898 24.555102-10.44898 27.167347-13.583674l0.522449-0.522449c36.571429-51.722449 49.110204-64.261224 84.114286-69.485714 34.481633-5.22449 51.722449 5.22449 124.342857 51.2 65.828571 41.273469 96.130612 68.963265 88.816327 111.804082-2.089796 47.542857-38.138776 111.804082-79.412245 140.538775-28.212245 19.853061-66.873469 29.779592-112.84898 29.779592zM273.240816 142.628571c-18.808163 0-52.244898 9.926531-88.293877 39.183674l-1.044898 1.044898c-33.436735 22.465306-42.840816 48.065306-46.497959 78.889796-11.493878 120.685714 49.632653 259.134694 177.632653 400.195918 138.971429 153.077551 311.379592 219.428571 423.183673 219.428572 37.093878 0 67.395918-7.314286 87.771429-21.420409 33.436735-23.510204 60.604082-78.367347 61.648979-109.191836l0.522449-3.134694c2.089796-12.016327 4.179592-24.032653-70.008163-70.530612-71.053061-44.930612-78.367347-48.065306-95.608163-45.453062-17.763265 2.612245-21.420408 3.134694-56.42449 52.767347l-1.044898 1.044898c-17.763265 22.465306-40.75102 28.734694-56.946939 30.302041-52.767347 4.179592-122.253061-35.004082-206.367347-115.983673l-0.522449-0.522449c-132.179592-135.836735-104.489796-196.440816-68.963265-242.416327l2.612245-2.612245c5.746939-5.22449 10.971429-9.926531 16.718367-14.106122 16.195918-13.061224 24.032653-19.853061 26.122449-37.616327 2.089796-24.032653-15.15102-61.126531-50.677551-110.236735l-0.522449-0.522448c-32.914286-48.587755-36.04898-48.587755-51.2-48.587756-1.044898-0.522449-1.567347-0.522449-2.089796-0.522449z" fill="#707070" p-id="7860"></path>
        </svg>
        <p>Call Us</p>
        <p>+1 888 891 2855</p>
      </a>
      <a class="content-item" onclick="zE('messenger', 'open')">
        <svg
          t="1751511409583"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="11640"
          width="32"
          height="32"
        >
          <path d="M896 685.408V192a32 32 0 0 0-32-32H160c-17.632 0-32 14.336-32 32v668.064l145.984-126.944a64.192 64.192 0 0 1 41.984-15.712H864a32 32 0 0 0 32-32zM864 96c52.928 0 96 43.072 96 96v493.408c0 52.928-43.072 96-96 96H315.968l-145.952 126.944a63.552 63.552 0 0 1-46.464 15.552A64.096 64.096 0 0 1 64 860.064V192c0-52.928 43.072-96 96-96h704z m-204.576 252.576a32 32 0 1 1 0 64H333.696a32 32 0 0 1 0-64h325.76z m-131.776 148.576a32 32 0 1 1 0 64h-193.92a32 32 0 0 1 0-64h193.92z" fill="#707070" p-id="11641"></path>
        </svg>
        <p>Live chat</p>
        <p>Chat with us</p>
      </a>
      <a class="content-item" href="/pages/track-your-order">
        <svg
          t="1751511574105"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="22209"
          width="32"
          height="32"
        >
          <path d="M768 704 384 704l0-64 384 0L768 704zM768 384 384 384l0 64 384 0L768 384zM768 512 384 512l0 64 384 0L768 512zM768 768 384 768l0 64 384 0L768 768zM128 832l64 0 0 64L128 896 64 896l0-64L64 0l576 0 64 0 0 64 0 64-64 0L640 64 128 64 128 832zM256 192l0 832 640 0L896 192 256 192zM832 960 320 960 320 256l512 0L832 960z" fill="#707070" p-id="22210"></path>
        </svg>
        <p>Track order</p>
      </a>
    </div>
  </div>
  `;
  const overlay = createOverlay();
  const popup = document.createElement("div");
  popup.innerHTML = popupHTML;
  if (!overlay || !popup) return;
  overlay.append(popup);
  // 点击遮罩层关闭
  overlay.addEventListener("click", function (event) {
    // 只有当点击的是遮罩层本身时才触发
    if (event.target === event.currentTarget) {
      overlay.remove();
    }
  });
  // 点击关闭按钮关闭
  popup.querySelector(".close-btn").addEventListener("click", function (event) {
    overlay.remove();
  });
}

// 表单输入框添加自定义自动填充功能
function setupAutoFill(inputId) {
  const inputElement = document.querySelector(`#${inputId}`);
  if (!inputElement) return;

  // 失焦时保存数据到localStorage
  inputElement.addEventListener("blur", function () {
    if (this.value.trim()) {
      localStorage.setItem(`form_${inputId}`, this.value.trim());
    }
  });

  // 自动填充
  const savedValue = localStorage.getItem(`form_${inputId}`);
  if (!inputElement.value.trim() && savedValue) {
    inputElement.value = savedValue;
  }

  // // 聚焦时显示气泡提示
  // inputElement.addEventListener("focus", function () {
  //   // 如果输入框为空且localStorage中有保存的数据
  //   if (!this.value.trim()) {
  //     const savedValue = localStorage.getItem(`form_${inputId}`);
  //     if (savedValue) {
  //       // 移除已有的提示框
  //       const existingTooltip = document.querySelector(
  //         `.autofill-tooltip[data-input="${inputId}"]`
  //       );
  //       if (existingTooltip) {
  //         existingTooltip.remove();
  //       }
  //       // 创建气泡提示框
  //       const tooltip = document.createElement("div");
  //       tooltip.className = "autofill-tooltip";
  //       tooltip.dataset.input = inputId;
  //       tooltip.innerHTML = `Use saved: <strong>${savedValue}</strong>`;
  //       tooltip.style.position = "absolute";
  //       tooltip.style.backgroundColor = "#333";
  //       tooltip.style.color = "white";
  //       tooltip.style.padding = "8px 12px";
  //       tooltip.style.borderRadius = "4px";
  //       tooltip.style.fontSize = "14px";
  //       tooltip.style.marginTop = "5px";
  //       tooltip.style.zIndex = "1000";
  //       tooltip.style.cursor = "pointer";
  //       tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.2)";
  //       tooltip.style.whiteSpace = "nowrap";
  //       tooltip.style.display = "none"; // 先隐藏，等待位置计算

  //       // 将提示框添加到输入框的父元素
  //       this.parentNode.appendChild(tooltip);

  //       // 计算并设置提示框位置
  //       const inputRect = this.getBoundingClientRect();
  //       const parentRect = this.parentNode.getBoundingClientRect();
  //       tooltip.style.top = inputRect.bottom - parentRect.top + "px";
  //       tooltip.style.left = inputRect.left - parentRect.left + "px";
  //       tooltip.style.display = "block";

  //       // 点击提示框自动填入数据
  //       tooltip.addEventListener("click", function () {
  //         inputElement.value = savedValue;
  //         this.remove();
  //       });

  //       // 点击其他地方隐藏提示框
  //       function hideTooltip(event) {
  //         if (
  //           !tooltip.contains(event.target) &&
  //           event.target !== inputElement
  //         ) {
  //           tooltip.remove();
  //           document.removeEventListener("click", hideTooltip);
  //         }
  //       }
  //       document.addEventListener("click", hideTooltip);
  //     }
  //   }
  // });
}
